module.exports = __webpack_public_path__ + "static/media/search.b8e6dc6f.svg";